import { PageHeader } from "@/CommonElements/PageTitle";
import { useOneOrderQuery } from "@/services/houseInspections";
import { Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ArrivalCardNoCol } from "../Reception/ArrivalCard";
import { LabelValue } from "@/Component/Value";
import { useLocalizedText } from "@/utils/hooks/useLocalizedText";
import { EXAMINATION_RESULT_STATUS } from "@/utils/constants";
import { Link } from "react-router";
import { Col } from "reactstrap";
import { Flex } from "antd";
import { Building06Icon } from "@hugeicons/core-free-icons/index";
import { HugeiconsIcon } from "@hugeicons/react";

export const HousingInspectionOrderHouses = () => {
  const { t } = useTranslation();
  const { getLocalizedText } = useLocalizedText();
  const { data: orderRes, isLoading } = useOneOrderQuery();
  const orders = isLoading
    ? { houses: Array.from({ length: 10 }).fill({ loading: true }) }
    : orderRes?.data?.data ?? [];
  const labelValues = [
    {
      key: "permit_no",
      label: t("PERMIT_NUMBER"),
      render: (value) => <LabelValue.Value value={value || "-"} />,
    },
    {
      key: "address",
      label: t("HOUSING_INSPECTION_BUILDING_ADDRESS"),
      render: (value, rowData) => (
        <LabelValue.Value
          value={
            value ||
            [rowData.houseCommercialNameAr, rowData.cityName].join(" - ")
          }
        />
      ),
      colSize: { xs: 12, md: 12 },
    },
    {
      key: "OwnerName",
      label: t("HOUSING_INSPECTION_DELEGATION_NAME"),
      render: (value) => <LabelValue.Value value={value || "-"} />,
    },
    {
      key: "REP_MOBILE_NO",
      label: t("HOUSING_INSPECTION_MOBILE_NUMBER"),
      render: (value) => <LabelValue.Value value={value || "-"} />,
    },
    {
      key: "order_code",
      label: t("HOUSING_INSPECTION_ORDERS"),
      render: (value) => {
        return <LabelValue.Value value={value || "-"} />;
      },
    },
    {
      key: "examination_count",
      label: t("HOUSING_INSPECTION_INSPECTION_COUNT"),
      render: (value) => <LabelValue.Value value={value || "-"} />,
    },
  ];

  const noOrdersFounde = !isLoading && !orders?.houses?.length;

  return (
    <>
      <PageHeader title={t("BUILDINGS")} />
      <Container fluid>
        <Row>
          {noOrdersFounde && <NoOrdersFound />}
          {orders?.houses?.map?.((order) => {
            return (
              <Col xs={12} md={6} lg={6} xl={4}>
                <Link
                  to={
                    order.loading
                      ? undefined
                      : `${order.house_id
                      }/housing-inspection-items?has_result=${!!order?.examination_result}`
                  }
                >
                  <ArrivalCardNoCol
                    loading={order.loading || false}
                    arrival={{ ...orders, ...order }}
                    labelValues={labelValues}
                    statusConfig={getExaminationResultStatus(
                      order?.examination_result?.status?.value,
                      getLocalizedText(
                        order?.examination_result?.status?.label_ar,
                        order?.examination_result?.status?.label_en
                      ),
                      t("IN_PROGRESS")
                    )}
                    title={
                      <Flex align="center" gap={10}>
                        <HugeiconsIcon
                          className="text-brand"
                          icon={Building06Icon}
                        />
                        <span>
                          {t("HOUSING_INSPECTION_BUILDING_NAME") + ": "}
                        </span>
                      </Flex>
                    }
                    titleValue={order.houseCommercialNameAr}
                  />
                </Link>
              </Col>
            );
          })}
        </Row>
      </Container>
    </>
  );
};

const getExaminationResultStatus = (status, text, defaultText) => {
  const mapStatus = {
    [EXAMINATION_RESULT_STATUS.qualified]: {
      color: "success",
      text,
    },
    [EXAMINATION_RESULT_STATUS.not_qualified]: {
      color: "danger",
      text,
    },
    default: {
      color: "brand",
      text: defaultText,
    },
  };
  return mapStatus[status] || mapStatus.default;
};
const NoOrdersFound = () => {
  const { t } = useTranslation();
  return (
    <div className="text-center py-5">
      <HugeiconsIcon icon={Building06Icon} size={48} className="text-muted" />
      <h4 className="text-muted mb-2">{t("NO_ORDERS_FOUND")}</h4>
    </div>
  );
};
